import axios from 'axios';

const API_URL = 'https://phone360.net/api/';

class AuthService {


        async login(email, password) {
            const response = await axios.post(API_URL + 'login', { email, password });
            return response.data; // Geri dönen veriyi döndür
        }
        async logout() {
          const response = await axios.get(API_URL + 'logout');
          return response.data; // Geri dönen veriyi döndür
      }
        async userList() {
          const token = localStorage.getItem('user');
          if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
          }
          const response = await axios.get(API_URL + 'users/');
          return response.data; // Geri dönen veriyi döndür
        
      }

      async getUser(id) {
        const token = localStorage.getItem('user');
        if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
        }
        const response = await axios.get(API_URL + 'users?id='+id);
        return response.data; // Geri dönen veriyi döndür
      
    }

    async searchUser(id) {
      const token = localStorage.getItem('user');
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
      }
      const response = await axios.get(API_URL + 'userSearch?key='+id);
      return response.data; // Geri dönen veriyi döndür
    
  }


      async deleteUser(userId) {
        const token = localStorage.getItem('user');
        if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
        }
        const response = await axios.delete(API_URL + 'users?id='+userId);
        return response.data;  
      
    }

      
      async addUser(userData) {

        const token = localStorage.getItem('user');
        if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
        }
        const response = await axios.post(API_URL + 'userPost',userData);
        return response.data; 
      }

      updateUserStatus(userId, status) {
        const token = localStorage.getItem('user');
        if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
        }

        return axios.put(API_URL + `users/${userId}/status`, { status });
      }
}

export default new AuthService();